import React from "react";
import styled from "styled-components";
import Header from "src/core/common/components/collections/menu/simple";
import OptionsList from "src/core/common/components/collections/menu/menu-elements/OptionsList";
import DeliveryBanner from "src/core/deliveries/components/DeliveryBanner";
import useFeatureToggles from "src/core/common/hooks/useFeatureToggles";
import dynamic from "next/dynamic";
import {logModuleLoadError} from "src/core/common/utils";

export default function DefaultBasePage({children, categoryBar, ...props}) {
  const toggles = useFeatureToggles();
  return (
    <div>
      <Header isSearchEnabled={true} options={<OptionsList />} />
      {!toggles.kioskMode() && <DeliveryBanner />}
      {categoryBar}
      <Content>{children}</Content>
      <ProductDetailModal {...props} />
    </div>
  );
}

const ProductDetailModal = dynamic(
  () =>
    import("src/core/pages/ProductDetail").catch(
      logModuleLoadError("ProductDetail", {critical: true})
    ),
  {
    ssr: false,
  }
);

const Content = styled.div`
  margin: 0 auto;
  max-width: ${({theme}) => theme.v1.content.maxWidth};
`;
